import { Dispatch, SetStateAction, useMemo } from "react";
import { MenuProps } from "@mui/material";
import { AppMenu } from "../../../../../../../../shared/components/AppMenu";
import { AppMenuItem } from "../../../../../../../../shared/components/AppMenu/AppMenuItem";
import { DIRECTIONS } from "../../../../../../Constants";
import { TDirection } from "../../../../../../types";
import { TMenuIds } from "../../../../../../../../app/state/menuSlice/types";
import { LayoutIcon } from "../../../../../../../../shared/icons/LayoutIcon";
import { useMenuSelectors } from "../../../../../../../../app/state/menuSlice/hook/use-menu-selectors";
import styles from "./styles.module.css";

interface Props extends Omit<MenuProps, "open"> {
  handleClick: Dispatch<SetStateAction<TDirection>>;
  direction: TDirection;
  handleClose: (id: TMenuIds) => void;
}

export const DirectionMenu = ({
  direction,
  handleClick,
  handleClose,
  ...rest
}: Props) => {
  const directionMenu = useMenuSelectors("select_layout_menu");
  const options = useMemo(() => {
    return DIRECTIONS.filter((direct) => direct !== direction);
  }, [direction]);

  return (
    <AppMenu
      open={directionMenu.isOpen}
      onClose={() => handleClose("select_layout_menu")}
      anchorReference={"anchorPosition"}
      anchorPosition={{
        left: (directionMenu.position?.x ?? 0) + 35,
        top: (directionMenu.position?.y ?? 0) + 16,
      }}
      transformOrigin={{
        vertical: "center",
        horizontal: "left",
      }}
      classes={{
        paper: styles["menu-paper"],
      }}
      className={styles["direction-menu"]}
      {...rest}
    >
      {options.map((option, index) => (
        <AppMenuItem
          key={`${option}-${index}`}
          onClick={() => {
            handleClick(option);
            handleClose("select_layout_menu");
          }}
        >
          <LayoutIcon className={styles[`icon-${option}`]} />
        </AppMenuItem>
      ))}
    </AppMenu>
  );
};
